import { useEffect } from 'react';

export default function useResizeEffect(ref, effect, deps = []) {
    useEffect(() => {
            if (!ref.current) {
                return
            }

            effect()

            if (typeof ResizeObserver === 'function') {
                var resizeObserver = new ResizeObserver(effect)
                resizeObserver.observe(ref.current, {
                    box: 'border-box',
                })

                return function() {
                    resizeObserver.disconnect(ref.current)
                    resizeObserver = null
                }
            } else {
                window.addEventListener('resize', effect)

                return function() {
                    window.removeEventListener('resize', effect)
                }
            }
        },
        deps.concat([ref.current])
    )
}
